/**
 * Ideally this should be fetched from the server through SSR.
 */

const StaticMetaData = {
    "full-stack-developer": {
        title: "Hire Experienced Full-Stack Developers for Web & Mobile Projects",
        description: "Find top-rated full-stack developers for your web & mobile app projects. Scale your team with experts from Dev-Hire, ready to deliver high-quality results."
    },
    "front-end-developer": {
        title: "Hire Skilled Front-End Developers for Responsive & User-Friendly Websites",
        description: "Hire expert front-end developers to build modern, responsive UIs. Ensure seamless user experiences with top talent from Dev-Hire."
    },
    "back-end-developer": {
        title: "Hire Experienced Back-End Developers for Scalable APIs & Systems",
        description: "Get top-tier back-end developers to build secure, scalable APIs & backend systems. Hire the best talent from Dev-Hire for your next project."
    },
    "mobile-developer": {
        title: "Hire Expert Mobile Developers for iOS & Android Apps",
        description: "Hire skilled mobile app developers for high-performance iOS & Android apps. Build custom, user-friendly mobile solutions with Dev-Hire experts."
    },
    "devops-engineer": {
        title: "Hire DevOps Engineers to Optimize Infrastructure & Continuous Delivery",
        description: "Hire DevOps engineers to improve cloud infrastructure and streamline CI/CD pipelines. Scale your engineering operations with Dev-Hire talent."
    },
    "data-scientist": {
        title: "Hire Expert Data Scientists for AI, ML & Analytics Projects",
        description: "Hire experienced data scientists to unlock valuable insights with AI, ML, and data analytics. Drive business growth with Dev-Hire experts."
    },
    "ai-developer": {
        title: "Hire AI Developers to Build Intelligent Automation & AI Solutions",
        description: "Hire skilled AI developers to build innovative AI systems, chatbots, and intelligent automation. Get expert solutions with Dev-Hire."
    },
    "ml-engineer": {
        title: "Hire Machine Learning Engineers for Scalable AI & ML Models",
        description: "Hire top machine learning engineers to develop scalable AI systems and predictive models. Transform your data into actionable insights with Dev-Hire."
    },
    "cloud-engineer": {
        title: "Hire Cloud Engineers to Optimize Cloud Infrastructure on AWS, Azure, and GCP",
        description: "Hire expert cloud engineers to scale and optimize your AWS, Azure, or GCP infrastructure. Get secure, efficient cloud solutions with Dev-Hire talent."
    },
    "data-engineer": {
        title: "Hire Data Engineers for Efficient Data Pipelines & Warehousing Solutions",
        description: "Hire expert data engineers to design and implement scalable data pipelines, data warehouses, and analytics systems with Dev-Hire."
    },
    "cyber-security": {
        title: "Hire Cybersecurity Experts to Safeguard Your Data & Infrastructure",
        description: "Hire experienced cybersecurity professionals to protect your data, networks, and systems. Build a secure infrastructure with Dev-Hire experts."
    },
    "python": {
        title: "Hire Skilled Python Developers for Web Apps, Data Science & AI Solutions",
        description: "Hire expert Python developers to build web applications, perform data science, and implement AI solutions. Get top talent from Dev-Hire."
    },
    "react": {
        title: "Hire Experienced React Developers for Scalable Front-End Web Applications",
        description: "Hire React developers to build fast, scalable, and responsive front-end web apps. Work with top React experts from Dev-Hire to grow your business."
    },
    "nodejs": {
        title: "Hire Node.js Developers for Scalable Back-End Systems & APIs",
        description: "Hire top Node.js developers to build secure and scalable back-end systems and APIs. Find experienced Node.js talent at Dev-Hire for your next project."
    },
}

export default StaticMetaData;